/* eslint-disable @typescript-eslint/no-explicit-any */
export abstract class UtilityService {

  // TODO this is used only in chart-builder, refactor and remove once highcharts are upgraded
  static parseAndAssign(obj: Record<string, unknown>, base?: Record<string, unknown>, overwrite?: boolean): unknown {
    if (obj !== undefined && obj !== null && Object.keys(obj).length > 0) {
      return Object.keys(obj)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        .reduce((clone: Record<string, unknown>, key: string): unknown => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          key.split('.').reduce((innerObj: Record<string, unknown>, innerKey: string, i: number, arr: Array<unknown>): unknown => {
            if (i + 1 === arr.length) {
              if (innerObj[innerKey] === undefined || overwrite) {
                return innerObj[innerKey] = obj[key];
              } else {
                // eslint-disable-next-line no-self-assign
                return innerObj[innerKey] = innerObj[innerKey];
              }
            } else {
              return innerObj[innerKey] = innerObj[innerKey] !== undefined ? innerObj[innerKey] : {};
            }
          }, clone);
          return clone;
        }, Object.assign({}, base));
    }
  }

  /**
   * Recursive cloning array.
   */
  static deepCloneArray<T>(arr: Array<T>): Array<T> {
    const clone = [];
    arr.forEach((item: T, index: number): void => {
      if (typeof item === 'object' && item !== null) {
        if (Array.isArray(item)) {
          clone[index] = UtilityService.deepCloneArray(item);
        } else if (UtilityService.isSpecificValue(item)) {
          clone[index] = UtilityService.cloneSpecificValue(item);
        } else {
          clone[index] = UtilityService.deepExtend({}, item);
        }
      } else {
        clone[index] = item;
      }
    });
    return clone;
  }

  /**
   * deep clone.
   */
  static deepClone(item: unknown): any {
    let clone;
    if (typeof item === 'object' && item !== null) {
      if (Array.isArray(item)) {
        clone = UtilityService.deepCloneArray(item);
      } else if (UtilityService.isSpecificValue(item)) {
        clone = UtilityService.cloneSpecificValue(item);
      } else {
        clone = UtilityService.deepExtend({}, item);
      }
    } else {
      clone = item;
    }
    return clone;
  }

  /**
   * Extending object that entered in first argument.
   *
   * Returns extended object or false if have no target object or incorrect type.
   *
   * If you wish to clone source object (without modify it), just use empty new
   * object as first argument, like this:
   *   deepExtend({}, yourObj_1, [yourObj_N]);
   */
  static deepExtend(...args: Array<any>): any {
    if (args.length < 1 || typeof args[0] !== 'object') {
      return false;
    }

    if (args.length < 2) {
      return args[0];
    }

    const target = args[0];

    // convert arguments to array and cut off target object
    const sourceObjects = Array.prototype.slice.call(args, 1);

    let val;
    let src;

    sourceObjects.forEach((obj: any): void => {
      // skip argument if isn't an object, is null, or is an array
      if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
        return;
      }

      Object.keys(obj).forEach((key: any): void => {
        src = target[key]; // source value
        val = obj[key]; // new value

        // recursion prevention
        if (val === target) {
          return;

          /**
           * if new value isn't object then just overwrite by new value
           * instead of extending.
           */
        } else if (typeof val !== 'object' || val === null) {
          target[key] = val;
          return;

          // just clone arrays (and recursive clone objects inside)
        } else if (Array.isArray(val)) {
          target[key] = UtilityService.deepCloneArray(val);
          return;

          // custom cloning and overwrite for specific objects
        } else if (UtilityService.isSpecificValue(val)) {
          target[key] = UtilityService.cloneSpecificValue(val);
          return;

          // overwrite by new value if source isn't object or array
        } else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
          // if the target is dom node, don't try deepExtend, it will hit the stack size limit
          if (val.toString() === '[object HTMLElement]') {
            target[key] = val;
          } else {
            target[key] = UtilityService.deepExtend({}, val);
          }
          return;

          // source value and new value is objects both, extending...
        } else {
          target[key] = UtilityService.deepExtend(src, val);
          return;
        }
      });
    });

    return target;
  }

  /**
   * Answers true if a given object is an empty Array, Map or Set collection.
   * Note: it doesn't support signed/unsigned integer typed arrays (Int8Array, Uint8Array) or WeakMap, WeakSet.
   *
   * @param collection - an object to be tested whether it is an empty collection
   */
  static isEmptyCollection(collection: unknown): boolean {
    if (collection === undefined || collection === null || typeof collection !== 'object') {
      return false;
    }
    return (collection instanceof Array && collection.length === 0)
       || ((collection instanceof Map || collection instanceof Set) && collection.size === 0);
  }

  /**
   * Return all enum values as a string array.
   *
   * @param entity - the enum object
   */
  static getEnumValues(entity: Record<string, string>): Array<string> {
    const enumValues = new Array<string>();
    for (const prop in entity) {
      if (typeof entity[prop] === 'string') {
        const value: string = entity[prop];
        enumValues.push(value);
      }
    }
    return enumValues;
  }

  private static isSpecificValue(val: unknown): boolean {
    return (val instanceof Date || val instanceof RegExp);
  }

  private static cloneSpecificValue(val: unknown): unknown {
    if (val instanceof Date) {
      return new Date(val.getTime());
    } else if (val instanceof RegExp) {
      return new RegExp(val);
    }
    throw new Error('Date or RegExp expected');
  }
}

// TODO see if this is a feasible replacement of deepExtend above
// function isObject(item): boolean {
//   return (item && typeof item === 'object' && !Array.isArray(item));
// }
//  export function mergeDeep(target, ...sources) {
//   if (!sources.length) {
//     return target;
//   }
//   const source = sources.shift();
//
//   if (isObject(target) && isObject(source)) {
//     for (const key in source) {
//       if (isObject(source[key])) {
//         if (!target[key]) {
//           Object.assign(target, {[key]: {}});
//         }
//         mergeDeep(target[key], source[key]);
//       } else {
//         Object.assign(target, {[key]: source[key]});
//       }
//     }
//   }
//
//   return mergeDeep(target, ...sources);
// }

